import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Circle } from 'lucide-react';
import { LoanDocument } from '../types';
interface DocumentItemProps {
  document: LoanDocument;
  onToggle: (id: string) => void;
}
export function DocumentItem({
  document,
  onToggle
}: DocumentItemProps) {
  const isComplete = document.status !== 'pending';
  return <motion.div layout initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} onClick={() => onToggle(document.id)} className={`
        flex items-center py-3.5 px-4 rounded-lg cursor-pointer select-none transition-all duration-200
        ${isComplete ? 'bg-green-50/50' : 'bg-white hover:bg-gray-50'}
      `} data-id="element-13">
      <div className={`
          w-6 h-6 rounded-md flex items-center justify-center mr-3 flex-shrink-0 border-2 transition-all duration-200
          ${isComplete ? 'bg-green-600 border-green-600 text-white' : 'border-gray-300 text-transparent hover:border-green-400'}
        `} data-id="element-14">
        <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-15" />
      </div>

      <h4 className={`text-sm font-medium transition-colors duration-200 ${isComplete ? 'text-slate-500 line-through' : 'text-slate-900'}`} data-id="element-16">
        {document.name}
      </h4>
    </motion.div>;
}